import { OwnerTransferVerifyButton } from './owner-transfer-verify-button.component'

import { useStyles } from './styles'

interface IProps {
  handleOpen: () => void
  handleClose: () => void
  open: boolean
}

export const NavButtons = (props: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.buttonsWrapper}>
      <OwnerTransferVerifyButton {...props} />
    </div>
  )
}
